export const clinicInfo = {
  name: "Dr. Khurana's",
  tagline: "Dental & Aesthetic Clinic",
  established: "Est. 2022",
  city: "Lucknow, India",
  location: "Chhatameel, Lucknow",
  phone: "+918601563494",
  phoneDisplay: "+91 86015 63494",
  whatsapp: "https://wa.me/918601563494",
  instagram: "https://www.instagram.com/drkhuranadentalclinic",
  instagramHandle: "@drkhuranadentalclinic",
  address: {
    line1: "UGF-2, Sharma Plaza",
    line2: "Raitha Road, Chhatameel",
    line3: "Lucknow - 226201",
  },
  hours: {
    weekday: "Mon – Fri · 10:00 AM – 9:00 PM",
    sunday: "Sunday · 10:00 AM – 9:00 PM",
    saturday: "Saturday · Closed",
  },
  mapsUrl: "https://share.google/wuvRqruqOjCyyC7J8",
  mapsEmbed: "https://www.google.com/maps?q=Dr.Khurana%27s+Dental+%26+Aesthetic+Clinic%2C+UGF-2%2C+Sharma+Plaza%2C+Raitha+Road%2C+Chhatameel%2C+Lucknow+226201&output=embed",
};

export const doctors = [
  {
    name: "Dr. Jaspreet Singh Khurana",
    role: "Founder & Chief Dental Surgeon · BDS, MDS (Periodontist) · Scientific Chairperson, IFAD",
    photo: "/images/hero/dr-jaspreet-optimized.webp",
    photoFit: "contain",
    bio: "Dr. Jaspreet Singh Khurana is the founder of Dr. Khurana's Dental & Aesthetic Clinic and one of Lucknow's most trusted names in restorative and cosmetic dentistry. As an MDS Periodontist, he brings deep expertise in dental implants, full-mouth rehabilitation, digital smile design and laser gum treatment — combining clinical precision with an artistic eye for aesthetics.",
    quote: "We don't just treat teeth — we design confident, healthy smiles that last a lifetime.",
  },
  {
    name: "Dr. Anshu Singh",
    role: "Co-Director · BDS (Gold Medalist), FMC · Vice President, IFAD",
    photo: "/images/doctors/dr-anshu-profile.jpg",
    photoFit: "cover",
    bio: "Dr. Anshu Singh is a Gold Medalist dental surgeon and Vice President of the Indian Federation of Advance Dentistry (IFAD). Life Member IFAD and certified with a Fellowship in Medical Cosmetology (FMC), she focuses on precision, aesthetics and patient-centered care — with core strengths in restorative & esthetic dentistry, endodontics and clear patient communication. Driven by a passion for continuous learning, she delivers predictable, minimally invasive treatment while keeping every patient comfortable and confident.",
    quote: "Every patient deserves to be heard first, and treated second. Comfort is not a luxury — it's the baseline.",
  },
];

export const stats = [
  { value: "5,000+", label: "Happy Patients" },
  { value: "★★★★★", label: "5-Star Rated on Google" },
  { value: "10+ yrs", label: "Combined Experience" },
  { value: "100%", label: "Painless Treatments" },
];

export const marqueeTreatments = [
  "Root Canal Treatment", "Teeth Whitening", "Gum Disease Treatment",
  "Crowns, Bridges & Dentures", "Pediatric Dentistry", "Aesthetic Dentistry",
  "Scaling & Polishing", "Dental Implants", "Wisdom Tooth Removal",
  "Invisalign & Braces", "Full Mouth Rehabilitation", "Preventive Care",
];

export const whyChoose = [
  { title: "Calm, private experience", desc: "Designed to make every visit feel relaxed and personal." },
  { title: "Modern dental technology", desc: "Precise diagnosis and treatment planning for lasting results." },
  { title: "Transparent care", desc: "Clear explanations and honest costs before every treatment decision." },
  { title: "Family-friendly dentistry", desc: "Gentle care for children, adults, and anxious patients." },
];

export const treatments = [
  { icon: "gem", title: "Dental Implants", desc: "Permanent, natural-looking tooth replacements that restore full function and lasting confidence.", href: "/dental-implants-lucknow/" },
  { icon: "shield", title: "Gum Disease Treatment", desc: "Advanced periodontal care to detect, treat and prevent gum disease — protecting your teeth and overall oral health.", href: "/gum-treatment-lucknow/" },
  { icon: "tooth", title: "Root Canal Treatment", desc: "Pain-free treatment using advanced rotary instruments — saving your natural tooth with minimal discomfort.", href: "/root-canal-treatment-lucknow/" },
  { icon: "sparkles", title: "Braces & Clear Aligners", desc: "Metal, ceramic and Invisalign options to straighten your smile at any age with precision and comfort.", href: "/clear-aligners-lucknow/" },
  { icon: "star", title: "Teeth Whitening", desc: "Professional in-clinic whitening delivering visibly brighter teeth in a single session.", href: "/teeth-whitening-lucknow/" },
  { icon: "crown", title: "Crowns, Bridges & Dentures", desc: "Custom-crafted crowns and bridges that restore damaged or missing teeth with a natural look and lasting strength." },
  { icon: "heart", title: "Pediatric Dentistry", desc: "Gentle, child-friendly care in a warm environment that builds positive dental habits for life." },
  { icon: "plus", title: "Tooth Extraction", desc: "Safe, gentle extractions including wisdom teeth — performed with minimal pain and fast recovery." },
  { icon: "hex", title: "Dental Fillings", desc: "Tooth-coloured composite fillings that restore cavities invisibly, matching your natural enamel." },
  { icon: "circle", title: "Scaling & Polishing", desc: "Professional deep cleaning to remove tartar, brighten teeth and protect against gum disease." },
];

export const faqs = [
  { q: "Does root canal treatment hurt?", a: "Root canal treatment is done with local anesthesia, so the procedure is designed to be comfortable. Mild soreness after treatment is normal and usually settles quickly." },
  { q: "How long do braces or aligners take?", a: "Most cases take around 12 to 24 months, depending on tooth movement, bite correction and how complex the alignment is. Clear aligners can sometimes be faster for mild cases." },
  { q: "Are dental implants safe?", a: "Yes. Dental implants are a safe, well-planned option when the gums, bone and overall oral health are suitable for treatment." },
  { q: "Do you treat children?", a: "Yes. We provide gentle dental care for children, including check-ups, preventive care and child-friendly treatment planning." },
  { q: "How do I book an appointment?", a: "You can book online by clicking the Book Appointment button, call +91 86015 63494, or message us on WhatsApp with the same number." },
];

export const testimonials = [
  { name: "Esha Khurana", initial: "E", text: "Hands down the best clinic in town, do visit to get dental services. Highly recommended 👍", verified: true, when: "July 2026" },
  { name: "Sanjay Bhargava", initial: "S", text: "Very good treatment and very good behavior — doctor and staff both. Really happy with the visit and the way everything was explained.", verified: true, when: "July 2026" },
  { name: "Mehul Gupta", initial: "M", text: "Super service, painless work, very cooperative with clients and reasonable fees. Would definitely visit again for any dental need.", verified: true, when: "July 2026" },
  { name: "Ajay Kumar Khare", initial: "A", text: "Excellent experience — the customer care standards here are truly noticeable. Professional team and a clean, welcoming clinic.", verified: true, when: "June 2026" },
  { name: "Mradul Singh", initial: "M", text: "The clinic reflects high standards of dental care with a patient-centered approach. Comfortable environment and warm doctors.", verified: true, when: "June 2026" },
  { name: "Verified Google Reviewer", initial: "G", text: "I had a wonderful experience at this dental clinic. Dr. Anshu Singh is highly skilled and gentle — she made the whole treatment stress-free.", verified: true, when: "June 2026" },
];

export const interiorImage = "/images/interior/clinic-interior-1-optimized.webp";
export const interiorImage2 = "/images/interior/clinic-interior-2-optimized.webp";
export const interiorImage3 = "/images/hero/clinic-hero-optimized.webp";
